import { User } from '@/models/User';
import { AxiosError } from 'axios';

export enum UserTypes {
    GET_USERS_CLEAR = '@user/GET_USERS_CLEAR',
    POST_USER_CLEAR = '@user/POST_USER_CLEAR',
    GET_USERS_REQUEST = '@user/GET_USERS_REQUEST',
    GET_USERS_SUCCESS = '@user/GET_USERS_SUCCESS',
    GET_USERS_FAILURE = '@user/GET_USERS_FAILURE',
    POST_USER_REQUEST = '@user/POST_USER_REQUEST',
    POST_USER_SUCCESS = '@user/POST_USER_SUCCESS',
    POST_USER_FAILURE = '@user/POST_USER_FAILURE',
    POST_FEEDBACK_REQUEST = '@user/POST_FEEDBACK_REQUEST',
    POST_FEEDBACK_SUCCESS = '@user/POST_FEEDBACK_SUCCESS',
    POST_FEEDBACK_FAILURE = '@user/POST_FEEDBACK_FAILURE',
    POST_FEEDBACK_CLEAR = '@user/POST_FEEDBACK_CLEAR',
}

export interface Users {
    users: [User];
    total: number;
}

export interface UsersState {
    data: Users;
    loading: boolean;
    hasError: boolean;
    error?: AxiosError;
    success: boolean;
}
